import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "AnswerResultView" }
const _hoisted_2 = { key: 0 }

import { ref, watchEffect, computed } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import dayjs from "dayjs";
import { useLoginUserStore } from "@/store/useStore";
import { getUserAnswerVoByIdUsingGet } from "@/api/userAnswerController";

interface Props {
  id: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AnswerResultView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

//@ts-ignore
const data = ref<API.UserAnswerVO>({});

const props = __props;

// 加载数据
const loadData = async () => {
  if (!props.id) {
    message.error("应用不存在");
    return;
  }
  const res = await getUserAnswerVoByIdUsingGet({ id: props.id as any });
  if (res.data.code === 0) {
    data.value = res.data.data as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 监听 searchParams 变量：触发加载
 */
watchEffect(() => {
  loadData();
});

//获取登录用户
const loginUserStore = useLoginUserStore();
let loginUserId = loginUserStore.loginUser?.id;

//是不是本人创建的应用
const isMy = computed(() => {
  return loginUserId && loginUserId === data.value.userId;
});

return (_ctx: any,_cache: any) => {
  const _component_P = _resolveComponent("P")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h1", { style: {"text-align":"center"} }, "答题结果", -1)),
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { style: {"margin-bottom":"16px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "auto",
              class: "content-wrapper"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", null, _toDisplayString(data.value.resultName), 1),
                (_unref(APP_TYPE_MAP)[data.value.appType!] === '得分类')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("p", null, "结果得分：" + _toDisplayString(data.value.resultScore), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, "结果描述：" + _toDisplayString(data.value.resultDesc), 1),
                _createElementVNode("p", null, "应用类型：" + _toDisplayString(_unref(APP_TYPE_MAP)[data.value.appType!]), 1),
                _createElementVNode("p", null, "评分策略：" + _toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[data.value.scoringStrategy!]), 1),
                _createVNode(_component_P, null, {
                  default: _withCtx(() => [
                    _createTextVNode("我的答案：" + _toDisplayString(data.value.choices), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, " 答题时间： " + _toDisplayString(_unref(dayjs)(data.value.createTime).format("YYYY-MM-DD HH:mm:ss")), 1),
                _createElementVNode("p", null, [
                  _cache[0] || (_cache[0] = _createTextVNode(" 答题人： ", -1)),
                  _createVNode(_component_a_avatar, {
                    size: 24,
                    style: { marginRight: '8px' },
                    "image-url": data.value.user?.userAvatar
                  }, null, 8, ["image-url"]),
                  _createVNode(_component_a_typography_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.value.user?.userName || "匿名"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, "应用 id:" + _toDisplayString(data.value.appId), 1),
                _createElementVNode("p", null, "结果 id:" + _toDisplayString(data.value.resultId), 1),
                _createVNode(_component_a_space, { size: "medium" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "secondary",
                      href: `/answer/do/${data.value.appId}`
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("重新答题 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["href"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      href: `/`
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("返回主页 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { flex: "320px" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_image, {
                    src: data.value?.resultPicture,
                    width: "100%"
                  }, null, 8, ["src"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})